module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jvrB1"))).then(() => parcelRequire('d0iPb'));